// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './not-authorized.scss';

function NotAuthorized(props) {
    const {children = 'Access is not granted'} = props;

    return <div className="not-authorized">{children}</div>;
}

NotAuthorized.propTypes = {
    children: PropTypes.node,
};

export default NotAuthorized;
